<template>
  <div class="main-component">
    <button class="btn btn-filter" @click="showFilter = !showFilter">
      <div class="filter-show" v-if="!showFilter">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 3H2L6.8 8.25556V11.8889L9.2 13V8.25556L14 3Z" stroke="black" stroke-opacity="0.65" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Фильтры
      </div>
      <div class="filter-close" v-else>
        <img src="@img/close.svg" alt="">
        Скрыть
      </div>
    </button>
    <transition name="show-filter">
      <FilterVue v-show="showFilter"></FilterVue>
    </transition>
    <div class="map-wrapper">
      <MapComponentVue/>
    </div>
  </div>
</template>

<script>
// import LandUseListVue from '../popup/LandUseListVue'
// import PopupVue from '../PopupVue'
import FilterVue from './FilterVue.vue'
import MapComponentVue from './MapComponent.vue'

export default {
  name: 'MainComponentVue',
  components: {
    FilterVue,
    MapComponentVue
    // LandUseListVue,
    // PopupVue
  },
  data () {
    return {
      isFull: false,
      showFilter: false
    }
  },
  methods: {
    closePopup () {
      return true
    }
  }
}
</script>

<style lang="scss">
.map-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.show-filter-enter-active,
.show-filter-leave-active {
  transition: all .2s;
}
.show-filter-enter,
.show-filter-leave-to {
  transform: translateY(1000px);
  opacity: 0;
}
.show-filter-enter-active,
.show-filter-leave-active {
  transition: all .3s;
}
.show-filter-enter,
.show-filter-leave-to {
  transform: translateY(-1000px);
  opacity: 0;
}

.main-component {
  position: absolute;
  top: 0;
  right: 0;
  width: calc(100% - 305px);
  min-height: 100%;
  transition: .3s;
  // background-color: #A5A5A5;
  /* &.full {
    width: calc(100% - 460px);
  } */
  @media screen and (max-width: 768px){
    width: 100%;
  }
  .btn-filter {
    position: absolute;
    top: 10px;
    right: 50px;
    border: 1px solid #e6e6e6;
    background-color: #fff;
    font-weight: 600;
    color: #595959;
    z-index: 2;
    transition: .3s;
    @media screen and (max-width: 768px){
      display: none;
    }
    &:hover {
      border-color: #4E53E7;
    }
    svg,
    img {
      display: inline-block;
      margin-right: 10px;
      vertical-align: bottom;
    }
  }
  .filter-close {
    img {
      margin-right: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/MainComponentVue.vue